import { getEntitySubdomain } from '@opengov/app-core/entity';
import { createSelector } from '@opengov/compose-app/reselect';

import { ReportTypes } from '../../../common/forms/reportForm/reportTypes';
import { reportLocaleText } from '../../../common/locale';
import { reportEffects } from '../../../common/report/effects';
import {
  selectNewReport,
  selectNewReportFormDescriptionValidationState,
  selectNewReportFormTitleValidationState,
  selectNewReportFormValidationState,
  selectNewReportTypeState
} from '../../selectors/selectReportCreateState';
import { reportCreateActionCreators } from '../../state/reportCreateState';
import { monitor } from '../../../performance';
import { NavigateFunction } from 'react-router-dom';

export const selectNewReportValidationState = createSelector(
  selectNewReportFormDescriptionValidationState,
  selectNewReportFormTitleValidationState,
  selectNewReportFormValidationState,
  (descriptionState, titleState, formState) => {
    return {
      descriptionState,
      titleState,
      formState
    };
  }
);

export const selectReportCreateTitleAndDescriptionProps = createSelector(
  selectNewReport,
  selectNewReportValidationState,
  selectNewReportTypeState,
  reportLocaleText,
  getEntitySubdomain,
  (newReport, validationState, reportType, localeText, entitySubdomain) => {
    const { descriptionState, titleState, formState } = validationState;

    return {
      newReport,
      reportLocaleText: localeText,
      titleState,
      descriptionValidationState: descriptionState,
      typeState: reportType,
      formState,
      onCreateNewReport: (navigate: NavigateFunction) => {
        const isMultiDataset = reportType === ReportTypes.MultiDataset;
        if (isMultiDataset) {
          void monitor.measureUntilDoneLoading({
            measureName: 'account-summary-create',
            additionalInfo: {
              entitySubdomain
            }
          });
        } else {
          const chartsAndDetailsCreationMeasurementObject = {
            measureName: 'charts-details-create',
            additionalInfo: {
              entitySubdomain: entitySubdomain
            },
            spinnerWaitOptions: {
              shouldDetect: true,
              selector: '[data-test="visualization-loading-indicator"]'
            }
          };
          void monitor.measureUntilDoneLoading(chartsAndDetailsCreationMeasurementObject);
        }
        reportEffects.createReportAndRedirect({
          isDimensional: [ReportTypes.AccountsSummary, ReportTypes.MultiDataset].includes(reportType),
          isMultiDataset,
          navigate
        });
      },
      onReportTitleBlur: (reportTitle) => reportCreateActionCreators.blurReportTitle(reportTitle),
      onReportDescriptionBlur: (reportDescription) =>
        reportCreateActionCreators.blurReportDescription(reportDescription),
      onReportTitleChange: (reportTitle) => reportCreateActionCreators.updateReportTitle(reportTitle),
      onReportDescriptionChange: (reportDescription) =>
        reportCreateActionCreators.updateReportDescription(reportDescription),
      onReportParentFolderChange: (parentFolderId?: number | null) =>
        reportCreateActionCreators.updateReportParentFolderId(parentFolderId)
    };
  }
);
